import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/about/AboutPageClient.tsx");
